"use client";
import { createContext, useContext } from "react";
export const DEFAULT_CHART_THEME = {
    background: "rgba(15, 23, 42, 0.45)",
    borderColor: "rgba(148, 163, 184, 0.18)",
    textColor: "#f8fafc",
    axisColor: "rgba(226, 232, 240, 0.7)",
    gridColor: "rgba(148, 163, 184, 0.22)",
    tooltipBackground: "rgba(2, 6, 23, 0.92)",
    tooltipBorderColor: "rgba(148, 163, 184, 0.3)",
    palette: ["#22d3ee", "#22c55e", "#f97316", "#a855f7", "#f472b6", "#94a3b8"],
};
const ChartThemeContext = createContext(DEFAULT_CHART_THEME);
export const ChartThemeProvider = ChartThemeContext.Provider;
export const useChartTheme = () => {
    return useContext(ChartThemeContext);
};
